module.exports = __webpack_public_path__ + "img/kingswinford_750x750.3cefaec2.jpg";